import _ from 'lodash'
export default new class Tools {
  // 创造对象
  buildObject(key, value) {
    let obj = {}
    obj[key] = value
    return obj
  }

  formatNumber(n) {
    n = n.toString()
    return n[1] ? n : '0' + n
  }

  // 数据分组
  arrByGroup(arr, param) {
    const that = this
    let new_arr = []
    let key = 0
    if (arr.length > 1) {
      arr.forEach((item, index) => {
        let new_item = {}
        new_item['data'] = []

        if (index === 0) {
          let format_date = that.formatDate(item[param])
          new_item[param] = item[param]
          new_item['date'] = format_date.date
          new_item['weekday'] = format_date.weekday
          new_item['data'].push(item)
          new_arr.push(new_item)
        } else {
          let format_date = that.formatDate(item[param])
          let prev_item = arr[index - 1]
          let prev_format_date = that.formatDate(prev_item[param])
          // 和前一个参数一致则在当前添加，否则添加至new_arr
          if (format_date.day == prev_format_date.day) {
            new_arr[key]['data'].push(item)
            new_arr[key]['date'] = format_date.date
            new_arr[key]['weekday'] = format_date.weekday
          } else {
            new_item[param] = item[param]
            new_item['date'] = format_date.date
            new_item['weekday'] = format_date.weekday
            new_item['data'].push(item)
            new_arr.push(new_item)
            key++
          }
        }
      })
    } else {
      let new_item = {}
      new_item['data'] = []
      let format_date = that.formatDate(arr[0][param])
      new_item[param] = arr[0][param]
      new_item['date'] = format_date.date
      new_item['weekday'] = format_date.weekday
      new_item['data'].push(arr[0])
      new_arr.push(new_item)
    }
    return new_arr
  }

  // 格式化日期
  formatDate(timestamp) {
    const that = this
    let current_day = new Date()
    let current_year = current_day.getFullYear()
    let current_month = current_day.getMonth() + 1
    let current_date = current_day.getDate()
    let d = new Date(timestamp * 1000)
    let date = {}
    let weekday = ''
    switch (d.getDay()) {
      case 1:
        weekday = '周一'
        break
      case 2:
        weekday = '周二'
        break
      case 3:
        weekday = '周三'
        break
      case 4:
        weekday = '周四'
        break
      case 5:
        weekday = '周五'
        break
      case 6:
        weekday = '周六'
        break
      case 0:
        weekday = '周日'
        break
      default:
        weekday = ''
    }
    date.year = d.getFullYear()
    date.month = d.getMonth() + 1
    date.day = d.getDate()
    date.date = date.month + '月' + date.day + '日'
    date.hours = d.getHours()
    date.hours = d.getHours()
    date.minutes = that.formatNumber(d.getMinutes())
    date.seconds = that.formatNumber(d.getMilliseconds())
    if (date.year == current_year && date.month == current_month) {
      if (date.day == current_date) {
        date.weekday = '今天'
      } else if (date.day == current_date + 1) {
        date.weekday = '明天'
      } else if (date.day == current_date + 2) {
        date.weekday = '后天'
      } else {
        date.weekday = weekday
      }
    } else {
      date.weekday = weekday
    }

    return date
  }

  // 获取字符串长度
  getStrLength(str) {
    let len = 0
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
        len += 2
      } else {
        len++
      }
    }
    return len
  }

  parseParams(data) {
    try {
      var tempArr = []
      for (var i in data) {
        var key = i
        var value = data[i]
        tempArr.push(key + '=' + value)
      }
      var urlParamsStr = tempArr.join('&')
      return urlParamsStr
    } catch (err) {
      return ''
    }
  }
}()



// WEBPACK FOOTER //
// ./src/utils/tools.js